/* Structured data (JSON-LD) builders for the new-look pages.
   Returns a schema.org @graph per route, baked into the prerendered HTML. */
import { SERVICES } from './data';
import { View, VIEW_PATHS } from './nav';

const SITE_URL = 'https://femtowareinfotech.com';
const LOGO = `${SITE_URL}/android-chrome-512x512.png`;
const ORG_ID = `${SITE_URL}/#organization`;
const WEBSITE_ID = `${SITE_URL}/#website`;

type Node = Record<string, unknown>;

const abs = (path: string): string => `${SITE_URL}${path === '/' ? '' : path}`;

const organization: Node = {
  '@type': 'Organization',
  '@id': ORG_ID,
  name: 'Femtoware Infotech LLP',
  url: SITE_URL,
  logo: LOGO,
  description:
    'Femtoware Infotech builds AI-native software and platforms with intelligent agents embedded into operations — reliable, secure and genuinely useful.',
  sameAs: [] as string[],
};

const website: Node = {
  '@type': 'WebSite',
  '@id': WEBSITE_ID,
  url: SITE_URL,
  name: 'Femtoware Infotech',
  publisher: { '@id': ORG_ID },
};

const localBusiness: Node = {
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#localbusiness`,
  name: 'Femtoware Infotech LLP',
  url: SITE_URL,
  image: LOGO,
  logo: LOGO,
  telephone: '+916360687215',
  email: 'contactus@fwinfotech.com',
  vatID: '32AAIFF1675Q1Z0',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'No. 268, 15 Ward, Karadka Post',
    addressLocality: 'Kasaragod',
    addressRegion: 'Kerala',
    postalCode: '671542',
    addressCountry: 'IN',
  },
  parentOrganization: { '@id': ORG_ID },
};

const serviceList: Node = {
  '@type': 'ItemList',
  name: 'Femtoware services',
  itemListElement: SERVICES.map((s, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    item: {
      '@type': 'Service',
      name: s.name,
      description: s.desc,
      provider: { '@id': ORG_ID },
      areaServed: 'Worldwide',
    },
  })),
};

const breadcrumb = (view: View, label: string): Node => {
  const itemListElement: Node[] = [
    { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
  ];
  if (view !== 'home') {
    itemListElement.push({
      '@type': 'ListItem',
      position: 2,
      name: label,
      item: abs(VIEW_PATHS[view]),
    });
  }
  return { '@type': 'BreadcrumbList', itemListElement };
};

/** schema.org @graph for a route, passed to the SEO component as jsonLd. */
export const buildJsonLd = (view: View, label: string): Record<string, unknown> => {
  const graph: Node[] = [organization, website, breadcrumb(view, label)];
  if (view === 'services') graph.push(serviceList);
  if (view === 'about' || view === 'contact') graph.push(localBusiness);
  return { '@context': 'https://schema.org', '@graph': graph };
};
